import './ActionsButton.scss'

import { Box }                     from '@chakra-ui/react';
import { Button }                  from "@/components/ui/button";
import { MenuContent }             from "@/components/ui/menu";
import { MenuItem }                from "@/components/ui/menu";
import { MenuRoot }                from "@/components/ui/menu";
import { MenuTrigger }             from "@/components/ui/menu";
import React                       from 'react'
import { Text }                    from '@chakra-ui/react';
import { observer }                from 'mobx-react';

export type Action = {
	label: string,
	type?: 'remove',
	do: () => void,
	disabled?: boolean,
}

interface IActionsButtonProps {
	actions: Action[];
}

const ActionsButton = observer((props: IActionsButtonProps) => {
	const { actions } = props;
	
	return (
		<MenuRoot>
			<MenuTrigger asChild>
				<Button unstyled outline="none">
					<ActionButton />
				</Button>
			</MenuTrigger>
			<MenuContent>
				{
					actions.map(action => {
						return (
							<MenuItem 
								key={action.label} 
								_hover={{ cursor: 'pointer', backgroundColor: 'gray.100' }} 
								value={action.label} 
								onClick={() => action.disabled ? false : action.do()} 
								disabled={action.disabled}
								style={{
									color: action.type === 'remove' ? 'red': 'unset',
								}}
							>
								{action.label}
							</MenuItem>
						);
					})
				}
			</MenuContent>
		</MenuRoot>
	);
})

export default ActionsButton;

const ActionButton = () => {

	const [isHovered, setIsHovered] = React.useState(false);
	
	return (
		<Box
			display="flex"
			alignItems="center"
			borderColor="blackAlpha.700"
			borderWidth="1px"
			borderRadius="8px"
			paddingTop="4px"
			paddingRight="7px"
			paddingBottom="4px"
			paddingLeft="7px"
			transition="background 0.2s ease-in-out"
			_hover={{ 
				cursor: "pointer", 
				bg: "gray.200"
			}}
			onMouseEnter={() => setIsHovered(true)}
			onMouseLeave={() => setIsHovered(false)}
		>
			<Box animation={isHovered ? '0.8s linear 0s bounce' : 'unset'}><Text fontSize="16px" >•</Text></Box>
			<Box animation={isHovered ? '0.8s linear 0.12s bounce' : 'unset'}><Text fontSize="16px" >•</Text></Box>
			<Box animation={isHovered ? '0.8s linear 0.24s bounce' : 'unset'}><Text fontSize="16px" >•</Text></Box>
		</Box>
	)
}